import { pickBy } from '@/utils'
import AttrItem from './attr-item'

export default {
  name: 'hotTopic',
  setting: [
    { label: '標題', key: 'title', component: 'input', value: '標題' },
    { label: '副標題', key: 'subtitle', component: 'input', value: '分享有好禮，拚單更便宜' },
    { label: '組件間距', key: 'padded', component: 'switch', value: true },
    {
      label: '話題',
      key: 'data',
      component: function (h, { key }) {
        return <AttrItem v-model={this.value[key]} />
      },
      value: [
        {
          id: '',
          topic: '話題'
        }
      ]
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data } = v
    return {
      name,
      ...base,
      data
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      data: 'data'
    })
  }
}
